import { FgpDgcLaunchData } from '@/features/providers/dgc/types';

export const buildDgcUrl = (input: FgpDgcLaunchData): string =>
  input.launchDetails.url;
